import React from "react";

import { Link } from "react-router-dom";
import { dataListsType } from "./featured-posts";
import LazyImage from "./lazyImage";

type Props = {
  props: dataListsType[];
};

const CardAll: React.FC<Props> = ({ props }) => {
  let data = {
    id: props[0]?.id,
    title: props[0]?.title,
    urlinform: props[0]?.urlinform,
    img: props[0]?.images,
    category: props[0]?.category,
    tags: props[0]?.tags,
    description: props[0]?.description,
    body: props[0]?.body,
    css: props[0]?.css,
  };

  // const navigate = useNavigate();

  // const handleClickDetailsPage = (dataProps: any) => {
  //   navigate(`/detailspage`, { state: dataProps });
  // };

  return (
    <Link
      rel="stylesheet"
      target="_top"
      to={{
        pathname: `/detailspage`,
        search: `?id=${data.id}&${data.category}/${data.urlinform}/`,
      }}
    >
      <div
        className="h-[490px] relative rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transform transition-transform duration-500 ease-in-out hover:-translate-y-2 cursor-pointer"
        // onClick={() => handleClickDetailsPage(data)}
      >
        <LazyImage
          src={data.img?.[0]}
          alt={data.title}
          className="w-full h-full object-cover"
        />

        <div className="absolute z-50 bottom-10 left-0 px-8">
          <div className="flex flex-col">
            <span className="capitalize text-xl font-bold text-[#609b25] mb-1">
              {data.category}
            </span>
            <span className="text-3xl text-white">
              <b className="font-extrabold">{data.title}</b>
              <i className="text-opacity-0 text-[#c84e47] text-xs">
                | The Asia Wander
              </i>
            </span>

            <span className="w-full mt-4 font-medium text-lg text-white line-clamp-3">
              {data.description}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CardAll;
